import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources';
import { isInterfaceLanguage, readLanguagePreference, writeLanguagePreference } from './languagePreference';

export function createAppI18n({ language, getStorage } = {}) {
  const instance = createInstance();
  instance.use(initReactI18next).init({
    lng: isInterfaceLanguage(language) ? language : readLanguagePreference(getStorage),
    fallbackLng: 'pl',
    supportedLngs: ['pl', 'en'],
    load: 'languageOnly',
    resources,
    defaultNS: 'common',
    initAsync: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
  return instance;
}

const appI18n = createAppI18n();

export async function setInterfaceLanguage(language, instance = appI18n, getStorage) {
  if (!isInterfaceLanguage(language)) return false;
  await instance.changeLanguage(language);
  if (typeof document !== 'undefined') document.documentElement.lang = language;
  writeLanguagePreference(language, getStorage);
  return true;
}

export default appI18n;
